import { jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync } from './ComponentSync.js';
import { TS_ErrorBoundary } from '../components/TS_ErrorBoundary/index.js';
export class Controller extends ComponentSync {
    constructor(props) {
        super(props);
        const __render = this.render.bind(this);
        // override default render to make sure error boundary is added if needed
        this.render = () => {
            if (this.props.ignoreError)
                return __render();
            return _jsx(TS_ErrorBoundary, { onClick: this.onErrorBoundaryClick, children: __render() });
        };
    }
    /**
     * Default on click on error boundary event
     * @param e - Mouse click event
     */
    onErrorBoundaryClick = (e) => {
        if (e.metaKey)
            return this.logInfo('Component props and state', this.props, this.state);
        if (e.shiftKey) {
            this.logInfo('Re-deriving state');
            return this.reDeriveState();
        }
        this.forceUpdate();
    };
}
//# sourceMappingURL=Controller.js.map